import React, { useState, useEffect } from 'react';
import { ModalTowButton } from "../../../../utils/modals/modalInfoTowButton";
import { ModalUbicaciones } from "../../../users_auth/components/modals/modalUbicaciones";
import { Grid, Paper, Button, FormControl, InputLabel, Select, InputAdornment, MenuItem, Table, TableHead, TableRow, TableCell, Typography } from "@material-ui/core"
import MigaPan from '../../../../app/orussystem/component/MigaPan';
import { ROL_USER, USER_ID } from '../../../../app/api-client/constants';
import { useDispatch } from 'react-redux';
import { clientOfUser, getlistUbicacionesAdmin, updateStatus } from '../../../domain/api/UbicacionesApi';
import { Store } from 'react-notifications-component';
import { makeStyles } from '@material-ui/core/styles';
import { panelUsersAuthStyle } from "../../../users_auth/panelUsersAuthStyle";
import { ListUbicaciones } from './ListUbicaciones';
import TablePagination from '@material-ui/core/TablePagination';
import { BiSearch } from "react-icons/bi";
import theme from '../../../../app/config/themaConfig';



const useStyles = makeStyles((theme) => ({
    root: {
        display: '1 0 auto',
        borderRadius: '18px',
        background: 'primary',

    },
    details: {
        display: 'flex',
        flexDirection: 'column',

    },
    content: {
        flex: 'auto',
        background: '#ffffff',
        display: 'flex',

    },
    cover: {
        width: 151,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
    contentContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    button: {
        marginLeft: 'auto',
        height: 50,
        width: 100,
        alignItems: 'center',
        justifyContent: 'center',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '600px',
        margin: 'auto'

    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        borderRadius: '10px'
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    input: {
        display: 'none',
    },
    root: {
        display: '1 0 auto',
        borderRadius: '18px',
        background: process.env.REACT_APP_PRIMARY_THEMA,

    },
    details: {
        display: 'flex',
        flexDirection: 'column',

    },
    content: {
        flex: 'auto',
        background: '#ffffff',
        display: 'flex',

    },
    cover: {
        width: 151,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
    hidden: {
        display: 'none',
    },
    searchContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end', // Alinea al final (derecha)
        paddingRight: theme.spacing(1), // Agrega un poco de espacio a la derecha
    },
    searchInputContainer: {
        display: 'flex',
        borderRadius: '20px 0px 0px 20px',
        height: '32px',
        fontSize: '16px',
    },
    searchInput: {
        border: '1px solid  #b6b7b7',
        borderRadius: '20px 0px 0px 20px',
        padding: '4px 8px',
        height: '100%',
        fontSize: 'inherit',
        outline: 'none',
        flex: 1,
    },
    searchButton: {
        background: '#0088FE',
        color: 'white',
        borderRadius: '0px 50px 50px 0px',
        padding: '8px 16px',
        fontSize: '14px',
    },
    title: {
        marginBottom: '2.5%',
        marginTop: '30px',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        marginLeft: '2%',
        fontWeight: 'bold', fontSize: '25px'
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        width: '100%'
    },
}));



export default function Ubicaciones() {
    const rol = localStorage.getItem(ROL_USER);

    const dispath = useDispatch();
    const classes = useStyles();
    const clases = panelUsersAuthStyle()
    const [loading, setLoading] = useState(false)
    const [busqueda, setBusqueda] = useState("")
    const [dataEdit, setdataEdit] = useState([])
    const [isEdit, setisEdit] = useState(false)
    const [isOpenModal, setisOpenModal] = useState(false)
    const [Estado, setEstado] = useState("all");
    const [Ubicaciones, setUbicaciones] = useState([]);
    const [totalElements, setTotalElements] = useState("");
    const rol_user_login = localStorage.getItem(ROL_USER)
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [page, setPage] = useState(0)
    const [isOpenModalChangeStatus, setisOpenModalChangeStatus] = useState(false)
    const [, data] = useState("");
    const [, setstateUser] = useState("")
    const [id, setid] = useState("");
    const [nombreUbi, setNombreUbi] = useState("");
    const IDCliente = localStorage.getItem(USER_ID)
    const ID = rol_user_login === 'ROLE_ADMIN' ? 0 : IDCliente




    const filtrar = () => {
        init("all", busqueda, 0, rowsPerPage)

    }
    //cambio de pagina
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
        init("all", "", newPage, rowsPerPage)

    };
    //cambio de tamaño
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        init("all", "", 0, event.target.value)


    };
    //cambio de estado
    const handleChange = (e) => {
        setEstado(e.target.value);
        init(e.target.value, "", 0, rowsPerPage)

    };


    const handledOpenModalState = (data) => {
        setid(data)
        setNombreUbi(data.value)
        setisOpenModalChangeStatus(true)
    }
    const handledOpenEditModal = (data) => {
        setdataEdit(data)
        setisEdit(true)
        setisOpenModal(true)
    }
    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });
        setTimeout(() => {

        }, 1000);
    }

    const init = async (estado, busqueda, page, size) => {

        let lista = [];

            const clientes = await clientOfUser(dispath, ID);
            //se consume el servicio seteando el ID con el ID del usuario para consumir el mismo servicio
             lista = await getlistUbicacionesAdmin(dispath, clientes.respuesta.id, estado, busqueda, page, size);
 

        try {
            //total de la lista
            if (lista.error !== "Internal Server Error") {
                setTotalElements(lista.totalElements)
                setUbicaciones(lista.content)
            } else {

                setUbicaciones([])
                handledAlert("Alerta", "No hay basculas asignadas para este usuario", "warning")
            }

        } catch (error) {

        }

    }
    const changeStatus = async () => {
        // console.log(id.id, "id users")
        const response = await updateStatus(dispath, id.id)

        try {

            if (response) {
                handledAlert("Actualizado Exitosamente!", `${nombreUbi} actualizado con exito!`, "success")
                setisOpenModalChangeStatus(false)
                init(Estado, busqueda, page, rowsPerPage)
            } else {
                handledAlert("Ocurrio un erro!", "Ocurrio un error al cambiar el estado", "danger")
            }

        } catch {
            handledAlert("Ocurrio un erro!", "Error interno", "danger")
        }
    }
 
    const handledOpenModal = () => {

        setisOpenModal(true)
        setdataEdit([])
        setisEdit(false)
    }


    useEffect(async () => {
        init(Estado, busqueda, page, rowsPerPage)

    }, [])
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            filtrar();
        }
    };
    const primaryColor = theme.palette.primary.main;


    return (
        <>
            {isOpenModal && <ModalUbicaciones
                setopenMondal={setisOpenModal}
                rowsPerPage={rowsPerPage}
                busqueda={busqueda}
                isOpen={isOpenModal}
                isEdit={isEdit}
                data={dataEdit}

                reload={init}

            />}

            {isOpenModalChangeStatus && <ModalTowButton
                setopenMondal={setisOpenModalChangeStatus}
                isOpen={isOpenModalChangeStatus}
                reload={init}
                title={"Señor usuario"}
                Messange={"¿Esta seguro de cambiar el estado de esta ubicacion?"}
                handledAccept={changeStatus}


            />}

            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage="Ubicaciones"
                    to="/"
                >
                    Home
                </MigaPan>
            </Grid>

            <Grid item xs={12}>


            </Grid>
            <Paper className={classes.paper} >
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} className={classes.searchContainer} >

                            <Typography className={classes.title} color='primary'>Ubicaciones </Typography>
                            {
                                rol === "ROLE_ADMIN" ?
                                    <Button variant="contained" color="primary" onClick={handledOpenModal}
                                        disabled={rol != "ROLE_ADMIN"} style={{ width: '15%', borderRadius: '10px', marginLeft: '2%' }}>
                                        CREAR
                                    </Button>
                                    : <></>

                            }

                            <Grid item xs={9} className={classes.searchContainer} >
                                <div className={classes.searchInputContainer}>
                                    <input
                                        id="descripcion"
                                        type="buscador"
                                        name="descripcion"
                                        onChange={filtrar}
                                        value={busqueda}
                                        onKeyPress={handleKeyPress}
                                        className={classes.searchInput}
                                        placeholder="Buscar"
                                        style={{
                                            border: `1px solid ${theme.palette.primary.main}`,
                                            borderRadius: '20px 0px 0px 20px',
                                            padding: '4px 8px',
                                            fontSize: 'inherit',
                                            outline: 'none',
                                            flex: 1,
                                        }}
                                    />
                                </div>
                                <Button onClick={filtrar} className={classes.searchButton}style={{ backgroundColor: theme.palette.primary.main }}>
                                    <BiSearch />
                                </Button>
                                <FormControl style={{ marginLeft: '5%', width: '20%' }}>
                                    <InputLabel id="demo-simple-select-label">filtrar Estado</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={Estado}
                                        label="Estado"
                                        onChange={handleChange}
                                        startAdornment={<InputAdornment position="start"></InputAdornment>}

                                    >

                                        <MenuItem value="all">Todos</MenuItem>
                                        <MenuItem value="activo">Activo</MenuItem>
                                        <MenuItem value="inactivo">inactivo</MenuItem>
                                    </Select>

                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            {/* Encabezados de la tabla */}


                            <Table>
                                <TableHead color='primary'>
                                    <TableRow color='primary'>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '6%', width: '25%',color:primaryColor }}>Nombre</TableCell>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '10%' ,color:primaryColor}}>Key</TableCell>
                                        <TableCell className={clases.TableCell} style={{ width: '15%', paddingLeft: '7%',color:primaryColor }}>Estado</TableCell>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '10%' ,color:primaryColor}}>Cliente</TableCell>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '20%',color:primaryColor }}>Fecha de actualizacion</TableCell>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '5%',color:primaryColor }}>Acciones</TableCell>


                                    </TableRow>
                                </TableHead>
                            </Table>
                        </Grid>
                        <Grid item xs={12}>
                            <ListUbicaciones
                                rows={Ubicaciones}
                                openModalEdit={handledOpenEditModal}
                                classes={clases}
                                changeStatus={handledOpenModalState}
                                isLoanding={loading}

                            />
                        </Grid>
                    </Grid>
                    <Paper className={clases.paper}>

                        <TablePagination
                            component="div"
                            count={totalElements}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage="Datos por página:"
                            style={{ color: primaryColor }}
                        />
                    </Paper>
                </Grid>
            </Paper>
        </>
    )
}